import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useAuth } from '../../../../contexts/authContext';
import { pricingApiConnect } from '../../../../lib/api/pricingApi.connect';
import { projectDataClient } from '../../../../lib/connect/clients';
export function usePricingScope(projectId, scenarioId = '', period = 'base') {
    const { user } = useAuth();
    return {
        principal: user ? `${user.tenant_id}:${user.id}` : '',
        projectId,
        scenarioId,
        period
    };
}
function key(name, s) {
    return [
        name,
        s.principal,
        s.projectId,
        s.scenarioId,
        s.period
    ];
}
export function usePricingRateBook(s) {
    return useQuery({
        queryKey: key('pricing-ratebook', s),
        enabled: !!s.principal,
        staleTime: 0,
        retry: false,
        queryFn: ({ signal })=>projectDataClient.getPricingRateBook({
                projectId: s.projectId,
                scenarioId: s.scenarioId,
                periodKey: s.period
            }, {
                signal
            })
    });
}
export function usePricingRateBookRow(s, categoryId) {
    return useQuery({
        queryKey: [
            ...key('pricing-ratebook-row', s),
            categoryId
        ],
        enabled: !!s.principal && !!categoryId,
        staleTime: 0,
        retry: false,
        queryFn: ({ signal })=>projectDataClient.getPricingRateBookRow({
                projectId: s.projectId,
                scenarioId: s.scenarioId,
                periodKey: s.period,
                categoryId
            }, {
                signal
            })
    });
}
export function usePricingTotals(s) {
    return useQuery({
        queryKey: key('pricing-totals', s),
        enabled: !!s.principal && !!s.scenarioId,
        staleTime: 0,
        retry: false,
        queryFn: ({ signal })=>projectDataClient.computePricingTotals({
                projectId: s.projectId,
                scenarioId: s.scenarioId
            }, {
                signal
            })
    });
}
const related = [
    'rate selections',
    'rate evidence entries',
    'rate observations',
    'pricing-detail',
    'pricing-project',
    'pricing-ratebook',
    'pricing-ratebook-row',
    'pricing-totals',
    'proposal-home',
    'proposal-record-header',
    'projectActivity',
    'pricing',
    'pricing-evidence',
    'proposalProject',
    'proposal-project',
    'lcats',
    'proposal-lcats',
    'lcat-registry-links'
];
export function usePricingWrite(mutationFn) {
    const client = useQueryClient();
    return useMutation({
        mutationKey: [
            'pricing-write'
        ],
        mutationFn,
        onSuccess: async ()=>{
            await Promise.all(related.map((name)=>client.invalidateQueries({
                    queryKey: [
                        name
                    ]
                })));
        }
    });
}
export function usePricingScenarios(s) {
    return useQuery({
        queryKey: key('pricing', s),
        enabled: !!s.principal,
        staleTime: 0,
        retry: false,
        queryFn: ()=>pricingApiConnect.listPricing(s.projectId)
    });
}
